
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Mumbaitopunecab() {



  const cardData =
  {
    keyword: ' Mumbai To Pune Cab',
    heading: 'SHREE Tours & Travels: Mumbai To Pune Cab',
    headingDescription: 'SHREE Tours & Travels offers a reliable Mumbai to Pune Cab service, ensuring a smooth and comfortable journey. Whether you are traveling for business, leisure, or returning home, our well-maintained Cabs and professional drivers provide a hassle-free experience. With on-time pickups, flexible booking options and affordable fares, we guarantee a safe and convenient ride. Choose SHREE Tours & Travels for a stress-free Mumbai to Pune travel experience.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is Mumbai’s most iconic landmark, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this majestic structure is a favorite tourist spot, offering stunning views, boat rides to Elephanta Caves and a lively atmosphere with street performers and photographers. The monument's historical significance and architectural beauty make it a must-visit destination in Mumbai."
    },
    {
        "title": "Marine Drive",
        "description": "Marine Drive, also known as the 'Queen’s Necklace,' is a scenic coastal road stretching along the Arabian Sea. The 3.6-km-long boulevard is lined with art deco buildings and offers breathtaking sunset views. Visitors can enjoy an evening stroll, feel the cool sea breeze, or relax on the promenade, making it one of the best places to experience Mumbai’s vibrant city life."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus (CSMT) is a magnificent railway station blending Victorian Gothic and Indian architectural styles. Built in 1887, it serves as a major transportation hub while also being an architectural marvel with intricate stone carvings, stained glass windows and grand domes. The station is a symbol of Mumbai’s rich colonial history and bustling urban energy."
    },
    {
        "title": "Elephanta Caves",
        "description": "Situated on Elephanta Island, the Elephanta Caves are a UNESCO World Heritage Site showcasing ancient rock-cut temples dedicated to Lord Shiva. Dating back to the 5th–7th century, these caves feature intricate sculptures, including the famous Trimurti sculpture of Shiva. A ferry ride from the Gateway of India takes visitors to this mystical site, offering a perfect blend of history, spirituality and scenic beauty."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai’s most revered religious sites, the Siddhivinayak Temple is dedicated to Lord Ganesha. Devotees, including Bollywood celebrities and politicians, visit this temple to seek blessings. The temple’s beautiful architecture, spiritual ambiance and divine presence make it a must-visit pilgrimage destination."
    },
    {
        "title": "Juhu Beach",
        "description": "Juhu Beach is one of Mumbai’s most famous and lively beaches, offering a perfect blend of relaxation and entertainment. The beach is lined with food stalls serving Mumbai’s iconic street food like Pav Bhaji, Bhel Puri and Vada Pav. It is also a great spot for an evening walk, horse rides and witnessing stunning sunsets."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Haji Ali Dargah is an iconic religious site located on a small island off the coast of Mumbai. This beautiful Indo-Islamic shrine houses the tomb of Saint Pir Haji Ali Shah Bukhari. Accessible via a narrow causeway during low tide, the dargah attracts thousands of devotees and tourists who come to experience its spiritual aura and scenic location."
    },
    {
        "title": "Colaba Causeway",
        "description": "Colaba Causeway is Mumbai’s shopping paradise, known for its vibrant street markets, trendy boutiques and cafes. From antique jewelry and handicrafts to stylish clothing and accessories, shoppers can find a variety of unique items here. The area is also home to iconic cafes like Café Leopold and Café Mondegar, making it a must-visit for shopping and dining enthusiasts."
    },
    {
        "title": "Sanjay Gandhi National Park",
        "description": "Sanjay Gandhi National Park is a lush green escape within Mumbai, home to diverse wildlife, including leopards, deer and numerous bird species. The park also houses the famous Kanheri Caves, ancient Buddhist rock-cut caves with stunning carvings. Ideal for nature lovers and adventure seekers, the park offers trekking trails, boating and a mini-train ride."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "The Bandra-Worli Sea Link is an engineering marvel connecting South Mumbai with the western suburbs. The Cable-stayed bridge offers breathtaking views of the city skyline, especially at night when it is beautifully illuminated. A drive across this iconic structure is a must for those looking to experience the modern side of Mumbai."
    }
],  
    
            
"services": [
    {
      "name": "Pune to Mumbai Airport Taxi",
      "description": "Book a comfortable and reliable taxi from Pune to Mumbai Airport. Our fleet of well-maintained cars and professional drivers ensure a smooth and timely journey."
    },
    {
      "name": "Pune to Mumbai Airport Cab Booking",
      "description": "Looking for a hassle-free Cab booking from Pune to Mumbai Airport? We offer affordable and reliable options for one-way and round-trip travel with experienced drivers."
    },
    {
      "name": "Pune to Mumbai Airport One-Way Taxi",
      "description": "Travel one-way from Pune to Mumbai Airport with ease. Our one-way taxi service ensures a convenient, cost-effective and timely journey."
    },
    {
      "name": "Pune to Mumbai Airport Round Trip Cab",
      "description": "Need a round-trip Cab from Pune to Mumbai Airport? Book with us for flexible and affordable round-trip options that suit your schedule and budget."
    },
    {
      "name": "Affordable Pune to Mumbai Airport Cab",
      "description": "Get affordable and comfortable Cab services from Pune to Mumbai Airport. Enjoy a reliable and hassle-free ride at budget-friendly prices."
    },
    {
      "name": "Private Taxi for Mumbai Airport from Pune",
      "description": "Book a private taxi for your journey from Pune to Mumbai Airport. Enjoy a personalized travel experience with professional drivers and comfortable vehicles."
    },
    {
      "name": "Mumbai Airport Travel from Pune by Cab",
      "description": "Travel from Pune to Mumbai Airport with ease by booking a Cab. Enjoy a stress-free and comfortable ride with our expert drivers."
    },
    {
      "name": "Group Travel to Mumbai Airport by Cab",
      "description": "Traveling in a group? Book a spacious Cab for your journey from Pune to Mumbai Airport. We offer comfortable vehicles for large groups at affordable rates."
    },
    {
      "name": "Book Pune to Mumbai Airport Car",
      "description": "Rent a car for your journey from Pune to Mumbai Airport. Choose from a variety of vehicles, including sedans, SUVs and luxury cars, for a comfortable ride."
    },
    {
      "name": "Mumbai Airport Cab Rental",
      "description": "Easily rent a Cab for your journey to or from Mumbai Airport. Our Cab rental service offers reliable vehicles and professional drivers at competitive prices."
    },
    {
      "name": "Pune to Mumbai Airport Drop",
      "description": "Need a drop-off at Mumbai Airport? Our drop service ensures timely and comfortable travel from your location in Pune to the airport."
    },
    {
      "name": "Mumbai Airport Pickup Service from Pune",
      "description": "Looking for a pickup from Mumbai Airport to Pune? Book our reliable airport pickup service for a smooth journey back to Pune with professional drivers."
    },
    {
      "name": "Luxury Taxi for Mumbai Airport",
      "description": "Experience luxury travel with our premium taxi service from Pune to Mumbai Airport. Travel in comfort and style with high-end vehicles like the Mercedes or Innova Crysta."
    },
    {
      "name": "Mumbai Airport to Pune Taxi Service",
      "description": "Book a Cab for a seamless ride from Mumbai Airport to Pune. Our taxi service ensures comfortable, timely and affordable travel."
    }
  ],

  "tableData": [
    ["- Pune to Mumbai Airport Taxi", "- Pune to Mumbai Airport Cab Booking"],
    ["- Pune to Mumbai Airport One-Way Taxi", "- Pune to Mumbai Airport Round Trip Cab"],
    ["- Affordable Pune to Mumbai Airport Cab", "- Private Taxi for Mumbai Airport from Pune"],
    ["- Mumbai Airport Travel from Pune by Cab", "- Group Travel to Mumbai Airport by Cab"],
    ["- Book Pune to Mumbai Airport Car", "- Mumbai Airport Cab Rental"],
    ["- Pune to Mumbai Airport Drop", "- Mumbai Airport Pickup Service from Pune"],
    ["- Luxury Taxi for Mumbai Airport", "- Mumbai Airport to Pune Taxi Service"]
  ],


  
  whychoose: [
    {
      "WhyChooseheading": "Reliable and Timely Service",
      "WhyChoosedescription": "Our Pune to Mumbai Airport Cab service ensures that you reach the airport on time, every time. With our punctual drivers and well-maintained vehicles, we prioritize your timely arrival for flights, taking the stress out of your journey. You can rely on us for a hassle-free airport transfer."
    },
    {
      "WhyChooseheading": "Comfortable Ride",
      "WhyChoosedescription": "Experience a comfortable ride with our spacious, clean and air-conditioned vehicles. Whether you're traveling to or from Mumbai Airport, we provide a smooth and relaxing experience so that you can enjoy your journey in comfort, without worrying about the road conditions."
    },
    {
      "WhyChooseheading": "Experienced Drivers",
      "WhyChoosedescription": "Our experienced and professional drivers know the best routes from Pune to Mumbai Airport, ensuring a safe, efficient and smooth journey. They focus on your comfort and safety, taking care of all the driving while you can relax or prepare for your flight."
    },
    {
      "WhyChooseheading": "Affordable Pricing",
      "WhyChoosedescription": "We offer affordable and transparent pricing for our Pune to Mumbai Airport Cab service. With no hidden charges, we provide great value for your money while ensuring quality service. Whether you're booking a one-way trip or a round trip, our pricing is budget-friendly."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "Our fleet of vehicles is regularly serviced and maintained to the highest standards to provide you with a safe and reliable ride. From cleanliness to mechanical checks, we ensure that your ride is comfortable, safe and worry-free for the entire duration of your journey."
    },
    {
      "WhyChooseheading": "Easy Booking Process",
      "WhyChoosedescription": "Booking a Pune to Mumbai Airport Cab with us is simple and convenient. You can easily book your Cab online through our user-friendly platform or get in touch with our customer service team for assistance. Whether you need a last-minute ride or a scheduled trip, our booking process is quick and hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Pune to Mumbai Airport transfer needs. Whether you have an early morning flight or need a late-night pickup, we are always available to accommodate your travel schedule. Our round-the-clock service ensures you're never left stranded."
    },
    {
      "WhyChooseheading": "Hassle-Free Experience",
      "WhyChoosedescription": "Our Pune to Mumbai Airport Cab service is designed to make your trip stress-free. From smooth booking to timely pickups and drop-offs, we handle all the details so you can focus on your journey. Enjoy a seamless and enjoyable experience from start to finish."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, customer satisfaction is our priority. We are committed to providing excellent service and ensuring that your Pune to Mumbai Airport Cab ride is comfortable, safe and punctual. We strive to exceed your expectations and guarantee a pleasant experience every time."
    }
  ]
  
  
  
  
  
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Pune to Mumbai Airport?",
        answer: "You can easily book your Pune to Mumbai Airport Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Pune to Mumbai Airport route?",
        answer: "We offer a variety of vehicles for the Pune to Mumbai Airport journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Pune to Mumbai Airport inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Pune to Mumbai Airport?",
        answer: "Yes, we offer one-way rental options for your Pune to Mumbai Airport trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Pune to Mumbai Airport trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Pune to Mumbai Airport Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Pune to Mumbai Airport Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Pune to Mumbai Airport trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Pune to Mumbai Airport?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Pune to Mumbai Airport?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Pune to Mumbai Airport journey was fantastic! The driver was on time and the ride was smooth and comfortable.',
        name: 'Mr. Rohit Sharma',
    },
    {
        text: 'I had a seamless experience with SHREE Tours & Travels. The driver was professional and I reached Mumbai Airport without any stress.',
        name: 'Miss. Priya Deshmukh',
    }
];









  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Mumbai to Pune Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/mumbai-to-pune-cab.jpg",
    "https://shreetoursandtravels.in/img/pune-to-mumbai-cab.jpg"
  ],
  "priceRange": "₹2500 - ₹4000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/mumbai-to-pune-cab-service",
    "priceCurrency": "INR",
    "price": 3000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.8,
    "reviewCount": 1400
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Sandeep Patil"
      },
      "datePublished": "2024-10-10",
      "reviewBody": "The Mumbai to Pune Cab service was smooth and comfortable. The driver was courteous and the trip was enjoyable. Highly recommended!"
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Neha Sharma"
      },
      "datePublished": "2024-11-15",
      "reviewBody": "Excellent service! The car was clean and the driver was professional. A great experience from Mumbai to Pune."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Mumbai to Pune Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 19.0760,  // Mumbai latitude
      "longitude": 72.8777  // Mumbai longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/mumbai-to-pune-cab-service"
  },
  "keywords": "Mumbai to Pune Taxi, Mumbai to Pune Cab Service, Mumbai to Pune One-Way Cab, Mumbai to Pune Round Trip Taxi, Affordable Mumbai to Pune Cab, Private Taxi for Pune from Mumbai, Pune Travel from Mumbai by Cab, Group Travel to Pune by Cab, Book Mumbai to Pune Car, Mumbai to Pune Cab Booking, Mumbai to Pune Luxury Taxi, Mumbai to Pune Budget Cab, Mumbai to Pune Family Taxi, Pune to Mumbai Taxi Rental"
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Mumbai to Pune Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Mumbai to Pune Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Mumbai to Pune Taxi, Mumbai to Pune Cab Service, Mumbai to Pune One-Way Cab, Mumbai to Pune Round Trip Taxi, Affordable Mumbai to Pune Cab, Private Taxi for Pune from Mumbai, Pune Travel from Mumbai by Cab, Group Travel to Pune by Cab, Book Mumbai to Pune Car, Mumbai to Pune Cab Booking, Mumbai to Pune Luxury Taxi, Mumbai to Pune Budget Cab, Mumbai to Pune Family Taxi, Pune to Mumbai Taxi Rental" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/10.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Mumbaitopunecab;